<template>
  <div>
    <div>
      <el-container>
        <el-aside width="340px">
          <div style="margin-bottom: 20px;text-align: left">
            <el-button size="small" type="danger" @click="createdItem">新 增</el-button>
            <el-input v-model="tableQuery.name" @change="selectRolePage" style="width: 160px;margin: 0 10px"
                      size="small" placeholder="请输入名称"></el-input>
          </div>
          <div style="height: 65vh;overflow: auto" v-loading="roleLoading">
            <el-tree :data="roleData">
                <span slot-scope="{ node, data }" style="width: 88%" @click="changeRolePage(data)">
                  <div class="custom-tree-node">
                    <div style="font-size: 14px;width: 80%;overflow: hidden;text-align: left; text-overflow: ellipsis;" :title="data.name">{{ data.name }}</div>
                    <div style="font-size: 14px">
                      <span @click="updateItem(data)" style="color: #409EFF;margin-right: 10px" class="el-icon-edit"></span>
                      <span @click="deleteItem(data)" style="color: #ff3f3f" class="el-icon-delete"></span>
                    </div>
                  </div>
                </span>
            </el-tree>
          </div>
        </el-aside>
        <el-main>
          <div style="margin-bottom: 20px">
            <el-popover placement="top" width="200" trigger="click">
              <div>
                <div style="margin-bottom: 10px;font-weight: bold">分配角色</div>
                <el-select v-model="setRoleCoachId" style="width: 180px;margin:0 10px" @change="setCoachRole"
                           filterable placeholder="请选择分配人" :loading="setRoleLoading"
                           remote reserve-keyword :remote-method="selectCoach">
                  <el-option v-for="(coach,index) in choiceCoachList" :key="index" :label="coach.name" :value="coach.id">
                    {{coach.id}} - {{coach.name}}
                  </el-option>
                </el-select>
              </div>
              <el-button :disabled="coachTableQuery.coachTitle == null" slot="reference" type="danger" style="margin-right: 10px">新 增</el-button>
            </el-popover>
            <el-tooltip class="item" effect="dark" content="点击左侧树解构进行切换！" placement="top">
              <el-input v-model="coachTableQuery.coachTitle" disabled style="width: 200px;margin-right: 10px" placeholder="请选择左侧树结构"></el-input>
            </el-tooltip>


            <el-input v-model="coachTableQuery.name" style="width: 200px;" @change="selectCoachPageByRole(coachTableQuery)" placeholder="请输入姓名"></el-input>
          </div>
          <el-table border class="table" :data="coachList"  height="600px" :cell-style="{padding:0+'px'}" v-loading="coachTableQuery.coachLoading"
                    :empty-text="coachTableQuery.coachTitle == '' ? '请选择左侧树结构':'空空如也～ '">
            <el-table-column width="70" property="coachId" label="ID"></el-table-column>
            <el-table-column width="180" property="coachName"  label="姓名">
              <template #default="coach">
                <div  style="display:flex;align-items: center">
                  <el-image style="width: 35px; height: 35px;border-radius: 6px;margin: 6px 10px 6px 0" :src="coach.row.portrait" :preview-src-list="[coach.row.portrait]">
                    <div slot="error" class="image-slot" style="display: flex;justify-content: center;">
                      <span class="el-icon-picture-outline" style="margin-top: 10px"></span>
                    </div>
                  </el-image>
                  <el-tooltip class="box-item" effect="dark" :content="coach.row.coachName" placement="top">
                    <div>{{ coach.row.coachName | truncate }}</div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="workNumber" label="工号"></el-table-column>
            <el-table-column property="coachPhone" show-overflow-tooltip label="电话"></el-table-column>
            <el-table-column property="dept.name" show-overflow-tooltip label="部门"></el-table-column>
            <el-table-column property="" show-overflow-tooltip label="校区"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template #default="scope">
                <div>
                  <el-popconfirm :title="'确定移除‘'+scope.row.coachName+'’的‘'+coachTableQuery.coachTitle+'’角色吗？'" @confirm="deleteCoachRole(scope.row.coachId)">
                    <el-button type="danger" slot="reference" size="mini">移 除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              style="text-align: right;margin: 20px 10px"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="coachTableQuery.pageSize"
              @current-change="changePage"
              layout="total, prev, pager, next, jumper"
              :total="coachTableQuery.total">
          </el-pagination>
        </el-main>
      </el-container>
    </div>
    <created-role @refresh="selectRolePage" ref="created"/>
    <update-role @refresh="selectRolePage" ref="update"/>
  </div>
</template>

<script>
import '/src/assets/styles.css';
import {selectRolePage,selectRoleGroup,selectCoachPageByRole,setCoachRole,deleteCoachRole} from '/src/api/contacts/role'
import CreatedRole from "./CreatedRole";
import UpdateRole from "./UpdateRole";
import {selectCoach} from "../../../../api/contacts/user";
export default {
  name: "Role",
  components:{CreatedRole,UpdateRole},
  data() {
    return {
      setRoleCoachId:null,
      choiceCoachList:[],
      setRoleLoading:false,
      coachTableQuery:{
        id:null,
        pageIndex:1,
        pageSize:11,
        coachTitle:null,
        name:"",
        coachLoading:false,
        total:0
      },
      coachList:[],
      tableQuery:{
        name:"",
      },
      roleData:[],
      roleGroup:[],
      roleLoading:false,
    }
  },
  methods:{
    /**
     * 选择分页
     */
    changePage(res){
      this.coachTableQuery.pageIndex = res;
      this.selectCoachPageByRole();
    },
    /**
     * 选择角色
     */
    changeRolePage(res){
      this.coachTableQuery.id = res.id;
      this.coachTableQuery.coachTitle = res.name;
      this.coachTableQuery.pageIndex = 1;
      this.selectCoachPageByRole();
    },
    /**
     * 根据角色查询教练
     */
    selectCoachPageByRole(){
      this.coachList = [];
      this.coachTableQuery.coachLoading = true;
      selectCoachPageByRole(this.coachTableQuery).then(val=>{
        if (val.status){
          this.coachList = val.data.list;
          this.coachTableQuery.coachLoading = false;
          this.coachTableQuery.total = val.data.total;
        }
      })
    },
    /**
     * 查询角色列表
     */
    selectRolePage(){
      this.roleLoading = true;
      selectRolePage(this.tableQuery).then(val => {
        this.roleLoading = false;
        if (val.status){
          this.roleData = val.data;
        }
      })
    },
    createdItem(){
      this.$refs.created.openDialog(this.roleGroup);
    },
    updateItem(item){
      this.$refs.update.openDialog(item,this.roleGroup);
    },
    deleteItem(){
      this.$notify({title: '提醒', message:"功能开发中...",type:'warning', offset: 40});
    },
    deleteCoachRole(coachId){
      let item = {coachId,roleId:this.coachTableQuery.id};
      deleteCoachRole(item).then(val=>{
        if (val.status == 200){
          this.selectCoachPageByRole()
          this.$notify.success({title: '提醒', message:"移除角色成功！", offset: 40});
        }else {
          this.$notify.error({title: '提醒', message:"移除角色失败！", offset: 40});
        }
      })
    },
    setCoachRole(){
      let item = {coachId:this.setRoleCoachId,roleId:this.coachTableQuery.id};
      setCoachRole(item).then(val=>{
        if (val.status == 200){
          this.selectCoachPageByRole()
          this.$notify.success({title: '提醒', message:"分配成功！", offset: 40});
        }else {
          this.$notify.error({title: '提醒', message:"分配失败！", offset: 40});
        }
      })
    },
    selectCoach(val){
      this.setRoleLoading = true;
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.setRoleLoading = false;
        this.choiceCoachList = val.data;
      })
    },
  },
  created() {
    this.selectRolePage();
    selectRoleGroup().then(val => {
      if (val.status){
        this.roleGroup = val.data;
      }
    })
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
.text-ellipsis {
  text-align: center;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
}
.el-aside {
  text-align: center;
  padding: 14px 6px 14px 14px;
  margin: 10px 10px;
  border-radius: 16px;
  box-shadow: 0 0px 20px 0 rgba(94, 93, 93, 0.1);
}
.text-ellipsis {
  text-align: center;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  width: 100%;
}
</style>